// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EmployeeBox__imageWrapper{margin-bottom:0}@media(min-width:1024px){.EmployeeBox__imageWrapper{margin-bottom:0}}.EmployeeBox__email,.EmployeeBox__phone,.EmployeeBox__position{display:flex}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
